export { default as Img200 } from './processed/200/LUTHER_S05.jpg';
export { default as Img400 } from './processed/400/LUTHER_S05.jpg';
export { default as Imgthumb } from './processed/thumb/LUTHER_S05.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/LUTHER_S05.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/LUTHER_S05.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      172,
      53,
      55
    ],
    "_population": 1314,
    "_hsl": [
      0.9971988795518207,
      0.5288888888888889,
      0.44117647058823534
    ]
  },
  "LightVibrant": {
    "_rgb": [
      252,
      236,
      220
    ],
    "_population": 5,
    "_hsl": [
      0.08333333333333333,
      0.8421052631578952,
      0.9254901960784314
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      101,
      31,
      32
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      148,
      108,
      100
    ],
    "_population": 1,
    "_hsl": [
      0.027777777777777773,
      0.19354838709677422,
      0.4862745098039216
    ]
  },
  "LightMuted": {
    "_rgb": [
      215,
      191,
      170
    ],
    "_population": 392,
    "_hsl": [
      0.07777777777777779,
      0.36000000000000015,
      0.7549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      58,
      68,
      69
    ],
    "_population": 677,
    "_hsl": [
      0.5151515151515151,
      0.08661417322834643,
      0.24901960784313726
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/LUTHER_S05.js